import { from, map, mergeMap, Observable, of, toArray } from 'rxjs';

/** Resolve only selected codes, with bounded API requests and concurrency. */
export function loadSelectedRows<T extends { plantation_code: string }>(
  ids: string[],
  fetch: (ids: string[]) => Observable<T[]>
): Observable<T[]> {
  const uniqueIds = [...new Set(ids)];
  if (!uniqueIds.length) return of([]);
  const batches: string[][] = [];
  for (let i = 0; i < uniqueIds.length; i += 500) {
    batches.push(uniqueIds.slice(i, i + 500));
  }
  return from(batches).pipe(
    mergeMap(fetch, 3),
    toArray(),
    map((results) => {
      const rows = new Map(
        results.flat().map((row) => [row.plantation_code, row])
      );
      // Keep selection order, exclude unrelated responses and drop removed rows.
      return uniqueIds.flatMap((id) => (rows.has(id) ? [rows.get(id)!] : []));
    })
  );
}
